/**
 * @see docs/worklog/TW-879-hunter-gbb-results-link/rfc.md
 */
import React, { FunctionComponent } from "react";

import { useGetHunterTireDetails } from "../../queries/useGetHunterTireDetails";
import { Placeholder } from "../../ui/Placeholder";

type HunterTireRowProps = {
  id: number;
};

export const HunterTireRow: FunctionComponent<HunterTireRowProps> = ({ id }) => {
  const { data, isLoading } = useGetHunterTireDetails(id);

  return (
    <tr className="bg-gray-50">
      {/* One cell per column in HunterTireTable, so the detail panel spans the row. */}
      <td className="px-2 py-4" colSpan={8}>
        <Placeholder className="block h-16 w-full" loading={isLoading}>
          <pre className="text-xs overflow-auto">
            {JSON.stringify(data, null, 2)}
          </pre>
        </Placeholder>
      </td>
    </tr>
  );
};
